module.exports = __webpack_public_path__ + "img/empty-questions-dark.009acbf7.svg";